var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _vm.customerItem.includes(_vm.item.item.id.toString())
        ? [
            _c("i", {
              directives: [{ name: "tooltip", rawName: "v-tooltip" }],
              staticClass: "fa fa-user-circle-o",
              attrs: {
                "data-toggle": "tooltip",
                "data-placement": "top",
                title: _vm.$translate("Bigtex5::Template.customerItemBought")
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
        [
          _c(
            "div",
            { staticClass: "thumb-image" },
            [
              _vm.attributeColors.length > 0 && _vm.showAttr === "true"
                ? [
                    _vm.attributeColors.length > 4
                      ? _c(
                          "ul",
                          {
                            staticClass: "cat-attr-color-list-text",
                            attrs: { role: "list" }
                          },
                          [
                            _c("li", [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Bigtex5::Template.manyColorsAvailable"
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      : _c(
                          "div",
                          { staticClass: "cat-attr-color-list d-none" },
                          [
                            _vm._l(_vm.attributeColors, function(attr) {
                              return [
                                _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: true,
                                        expression: "true"
                                      }
                                    ],
                                    attrs: {
                                      "aria-label": "goTo-color-" + attr.color,
                                      href: attr.itemUrl,
                                      "data-placement": "right",
                                      "data-toggle": "tooltip",
                                      "data-html": "true",
                                      "data-title":
                                        "<img src='" +
                                        attr.imageUrl +
                                        "' class='max-attr-image'>"
                                    }
                                  },
                                  [
                                    _c("span", {
                                      style: { backgroundColor: attr.color }
                                    })
                                  ]
                                )
                              ]
                            })
                          ],
                          2
                        )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.attributeText.length > 0 && _vm.showAttr === "true"
                ? [
                    _c(
                      "ul",
                      {
                        staticClass: "cat-attr-text-list",
                        attrs: { role: "list" }
                      },
                      [
                        _vm.attributeText.length > 9
                          ? _c("li", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Bigtex5::Template.manyVariationsAvailable"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ])
                          : _vm._l(_vm.attributeText, function(attr) {
                              return attr != "XXL" && attr != "2XL"
                                ? _c("li", { key: attr }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(attr) +
                                        "\n            "
                                    )
                                  ])
                                : _vm._e()
                            })
                      ],
                      2
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "prop-1-1" },
                [
                  _vm._t("item-image", [
                    _c("category-image-carousel", {
                      ref: "categoryImageCarousel",
                      attrs: {
                        "image-urls-data": _vm._f("itemImages")(
                          _vm.item.images,
                          _vm.imageUrlAccessor
                        ),
                        alt: _vm._f("itemName")(_vm.item),
                        title: _vm._f("itemName")(_vm.item),
                        "item-url": _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        ),
                        "enable-carousel":
                          _vm.$ceres.config.item.enableImageCarousel,
                        "disable-carousel-on-mobile":
                          _vm.disableCarouselOnMobile
                      }
                    })
                  ])
                ],
                2
              )
            ],
            2
          ),
          _vm._v(" "),
          _vm.blackday.tag.length > 0 && _vm.blackday.active
            ? [
                _c("div", { staticClass: "special-tags" }, [
                  _c(
                    "div",
                    { staticClass: "badge badge-new badge-primary blackday" },
                    [
                      _c("i", {
                        staticClass: "fa fa-fire",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.blackday.tag[0].names.name) +
                          "\n        "
                      )
                    ]
                  )
                ])
              ]
            : [
                _vm._t("store-special", [
                  _vm.storeSpecial ||
                  _vm.item.variation.bundleType === "bundle" ||
                  _vm.item.item.itemType === "set"
                    ? _c("item-store-special", {
                        attrs: {
                          "store-special": _vm.storeSpecial,
                          "recommended-retail-price": _vm.item.prices.rrp,
                          "variation-retail-price": _vm.item.prices.default,
                          "special-offer-price": _vm.item.prices.specialOffer,
                          "decimal-count": _vm.decimalCount,
                          "bundle-type": _vm.item.variation.bundleType,
                          "item-type": _vm.item.item.itemType
                        }
                      })
                    : _vm._e()
                ])
              ],
          _vm._v(" "),
          _c("csaddtolist", {
            attrs: { "variation-id": 0, "current-item-id": _vm.item.item.id }
          }),
          _vm._v(" "),
          _vm._t("item-details", [
            _c(
              "section",
              { staticClass: "thumb-content" },
              [
                _c("b", [
                  _vm._v(_vm._s(_vm.item.item.manufacturer.externalName) + " ")
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "thumb-title",
                    class: {
                      "stretched-link":
                        _vm.$ceres.config.global.shippingCostsCategoryId === 0
                    },
                    attrs: {
                      "aria-label": "kategorieartikel-" + _vm.item.texts.name1,
                      href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId)
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.item.texts.shortDescription) +
                        "\n          "
                    ),
                    _vm._l(_vm.item.groupedAttributes, function(attribute) {
                      return _c("span", { key: attribute }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm._f("translate")(
                                "Ceres::Template.itemGroupedAttribute",
                                attribute
                              )
                            ) +
                            "\n          "
                        )
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "thumb-meta mb-2" },
                  [
                    _vm._t("before-prices"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "priceflex text-center justify-content-center row",
                        class: { "cross-cont": _vm.isCrossedPrice }
                      },
                      [
                        _vm.isCrossedPrice
                          ? _c("div", { staticClass: "col-xl-6 col-12 px-0" }, [
                              _vm.item.prices.specialOffer
                                ? _c(
                                    "span",
                                    { staticClass: "catcross crossprice" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm._f("itemCrossPrice")(
                                              _vm.item.prices.default.unitPrice
                                                .formatted,
                                              true
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "catcross crossprice" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm._f("itemCrossPrice")(
                                              _vm.item.prices.rrp.unitPrice
                                                .formatted
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "price col-xl-6 col-12 px-0 " },
                          [
                            _vm.item.item.itemType === "set"
                              ? [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemSetPrice",
                                          { price: _vm.itemSetPrice }
                                        )
                                      ) +
                                      " *\n              "
                                  )
                                ]
                              : _vm.item.item && _vm.hasAbPrice
                              ? [
                                  _vm._v(
                                    "\n                 " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.categoryItemFromPrice",
                                          { price: _vm.itemPrice }
                                        )
                                      ) +
                                      " *\n              "
                                  )
                                ]
                              : [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm._f("specialOffer")(
                                          _vm.item.prices.default.unitPrice
                                            .formatted,
                                          _vm.item.prices,
                                          "unitPrice",
                                          "formatted"
                                        )
                                      ) +
                                      " *\n              "
                                  )
                                ]
                          ],
                          2
                        )
                      ]
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._t("after-prices")
              ],
              2
            )
          ])
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }